
(function () {
  'use strict';

  const SELECTOR = '[data-vip-countdown]';
  const INTERVAL = 1000;

  function getCountdownSections(scope) {
    const sections = [];

    if (scope instanceof Element && scope.matches(SELECTOR)) {
      sections.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      sections.push(...scope.querySelectorAll(SELECTOR));
    }

    return sections;
  }

  function initCountdown(scope) {
    const sections = getCountdownSections(scope);

    sections.forEach((section) => {
      if (section.dataset.countdownInitialized === 'true') return;

      section.dataset.countdownInitialized = 'true';

      const endDate = section.dataset.endDate;

      const daysEl = section.querySelector('[data-days]');
      const hoursEl = section.querySelector('[data-hours]');
      const minutesEl = section.querySelector('[data-minutes]');
      const secondsEl = section.querySelector('[data-seconds]');

      if (!endDate || !daysEl || !hoursEl || !minutesEl || !secondsEl) {
        console.warn('VIP Countdown: Missing date or timer elements.');
        section.hidden = true;
        return;
      }

      // Require ISO datetime with an explicit timezone offset.
      // Example: 2026-11-30T23:59:59-05:00
      const isoWithOffset =
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;

      if (!isoWithOffset.test(endDate)) {
        console.error(
          'VIP Countdown: Invalid format. Use YYYY-MM-DDTHH:mm:ss-05:00 for New York EST or the correct EDT offset.'
        );

        section.hidden = true;
        return;
      }

      const endTimestamp = Date.parse(endDate);

      if (Number.isNaN(endTimestamp)) {
        console.error('VIP Countdown: Invalid end date.');
        section.hidden = true;
        return;
      }

      let intervalId = null;

      function updateCountdown() {
        const remaining = endTimestamp - Date.now();

        // Hide the complete section when countdown expires.
        if (remaining <= 0) {
          if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }

          section.hidden = true;
          return;
        }

        // Make section visible while countdown is active.
        section.hidden = false;

        const totalSeconds = Math.floor(remaining / 1000);

        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      // Run immediately so expired countdowns are hidden on page load.
      updateCountdown();

      // Start interval only if countdown has not expired.
      if (endTimestamp > Date.now()) {
        intervalId = setInterval(updateCountdown, INTERVAL);
      }

      section._countdownInterval = intervalId;
    });
  }

  function destroyCountdown(scope) {
    const sections = getCountdownSections(scope);

    sections.forEach((section) => {
      if (section._countdownInterval) {
        clearInterval(section._countdownInterval);
      }

      delete section._countdownInterval;
      delete section.dataset.countdownInitialized;
    });
  }

  function initAllCountdowns() {
    initCountdown(document);
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCountdowns);
  } else {
    initAllCountdowns();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    initCountdown(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyCountdown(event.target);
  });

})();
